// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ja14[data-v-04a1746c]{position:absolute;top:25px;right:25px;cursor:pointer;transition:.3s}.ja14[data-v-04a1746c]:hover{opacity:.3}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"comp": "ja14"
};
module.exports = ___CSS_LOADER_EXPORT___;
